module.exports = {
	extends: [
		'/',
		'templates',
		'layoutTrees',
		'layoutTrees'
	],

	config: {
		isBulkMode: true,
		loadFullTreeGranted: false,
		isContainerSelector: true
	},

	methods: {
		dataDealer: function(){
			this.model.bulkContentBaseFilters = this.getResourceRegisterContent('bulkContentBaseFilters') || {}
			if(this.config.isContainerSelector){
				const bulkLayoutFilters = this.getResourceRegisterContent('bulkLayoutFilters') || {}
				if(bulkLayoutFilters.rootParentSectionComponentID){
					this.model.rootParentSectionComponentID = bulkLayoutFilters.rootParentSectionComponentID

					if(bulkLayoutFilters.sectionID){
						this.config.readyNodeID = `${bulkLayoutFilters.sectionID}_${bulkLayoutFilters.rootParentSectionComponentID}`;
						this.config.readyNodeContext = 'section';
					}
				}
			}
		},

		updateRootSectionComponentID: function(rootParentSectionComponentID = 0){
			this.model.rootParentSectionComponentID = rootParentSectionComponentID || 0

			if(this.model.rootParentSectionComponentID){
				this.config.readyNodeID = rootParentSectionComponentID;
				this.config.readyNodeContext = 'component';
				this.refreshTrees(false);
			} else {
				this.resourceData = {}
				delete this.config.readyNodeID
				delete this.config.readyNodeContext
				this.refresh(false)
			}
		},

		getResourceFilters: function(storage, resourceFilters, actionKey){
			if(actionKey === 'refreshResources'){
				resourceFilters = resourceFilters || {};
				resourceFilters.rootParentSectionComponentID = this.model.rootParentSectionComponentID
			}
			return resourceFilters;
		},

		loadResourcesGranted: function(storage, resourceFilters, actionKey, fieldCode, attachTriggerOptions){
			return actionKey !== 'refreshResources' || this.config.loadFullTreeGranted || (resourceFilters || {}).rootParentSectionComponentID > 0;
		},
	}
};
